
import { getURLParams, setURLParam } from './URLParams.utils';
import { EnvUtils } from './env.utils';
import { LocationUtils } from './auth/location.utils';

let cachedWorkspaceUrlBase: string | null = null;

export async function initializeWorkspaceUrlCache(): Promise<void> {
  if (EnvUtils.isDevelopment()) {
    return;
  }

  try {
    const workspaceUrl = await LocationUtils.getWorkspaceUrl();
    const urlString = workspaceUrl.toString();
    const locationParamIndex = urlString.indexOf('?location=');
    if (locationParamIndex !== -1) {
      cachedWorkspaceUrlBase = urlString.substring(0, locationParamIndex);
    } else {
      const queryIndex = urlString.indexOf('?');
      cachedWorkspaceUrlBase = queryIndex !== -1 ? urlString.substring(0, queryIndex) : urlString;
    }
  } catch (error) {
    console.error('Failed to initialize workspace URL cache:', error);
  }
}

export function getWorkspaceUrlBase(): string | null {
  return cachedWorkspaceUrlBase;
}

export function getFullWorkspaceLink(internalAppUrl: string): string {
  if (EnvUtils.isDevelopment() || !cachedWorkspaceUrlBase) {
    return internalAppUrl;
  }

  const fullInternalUrl = window.location.origin + internalAppUrl;
  const encodedLocation = encodeURIComponent(fullInternalUrl);
  return `${cachedWorkspaceUrlBase}?location=${encodedLocation}`;
}

export function getParameterizedLink(baseLink: string): string {

  if (!baseLink || typeof baseLink !== 'string') throw new Error('parameter "baseLink" must be a string');

  const organisationid = getURLParams(window.location.href)?.organisationid;
  const subscriptionId = getURLParams(window.location.href)?.subscriptionid;

  if (organisationid) {
    baseLink = setURLParam(baseLink, 'organisationid', organisationid);
  }

  if (subscriptionId) {
    return setURLParam(baseLink, 'subscriptionid', subscriptionId);
  }
  return `${baseLink}`;
}
